module.exports = __webpack_public_path__ + "d1d8dcfe.svg";